import ModalWrapper from '../../common/Modal/ModalWrapper'
import Button from '../../common/Button';
import { useNavigate } from 'react-router-dom';

const WarningInvestmentCriteria = () => {
    const navigate = useNavigate()

    return (
        <>
            <ModalWrapper
                modalType={'warningToCompleteInvestmentCriteria'}
                modalCardClasses='p2rem'
            >

                <p className='c15 tac mb2rem fs14px'>
                    You haven’t completed your Investment Criteria yet. Without it, the company analysis and suggestions may not be fully accurate. Click <span className='fw600'>Proceed</span> to complete your Investment Criteria, or select <span className='fw600'>Ignore & Proceed</span> to continue without completing it.
                </p>

                <div className='df aic jcc my1rem g1rem'>
                    <Button
                        customClassName='mr1rem'
                        text={"Proceed"}
                        onClick={() => navigate(`/investor-setting#InvestorMatch%20Criteria`)}
                    />
                    <Button
                        btnType="warning"
                        text={"Ignore & Proceed"}
                        onClick={() => navigate(`/manualAdd`)}
                    />
                </div>
            </ModalWrapper>
        </>
    )
}

export default WarningInvestmentCriteria